import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './styles.scss';
import ErrorMessage from '../ErrorMessage';
import ErrorHandler from '../ErrorHandler';
import Text from '../Text';

export default class Input extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    onKeyPress: PropTypes.func,
    onBlur: PropTypes.func,
    value: PropTypes.string,
    name: PropTypes.string,
    id: PropTypes.string,
    inputType: PropTypes.string,
    placeholder: PropTypes.string,
    autocomplete: PropTypes.any,
    hint: PropTypes.node,
    maxLength: PropTypes.number,
    validate: PropTypes.bool,
    isDisabled: PropTypes.bool,
    autoComplete: PropTypes.string,
    validation: PropTypes.object,
    className: PropTypes.string,
    formatError: PropTypes.func,
    currency: PropTypes.string,
    errorClassName: PropTypes.string,
    error: PropTypes.object,
    onFocus: PropTypes.func,
    onKeyDown: PropTypes.func,
    hintText: PropTypes.string,
  };

  static defaultProps = {
    onKeyPress: () => null,
    onBlur: () => null,
    maxLength: null,
    className: '',
    formatError: (value) => value,
    isDisabled: false,
    currency: null,
    autoComplete: 'off',
    value: '',
    errorClassName: '',
    error: null,
    onFocus: () => null,
    onKeyDown: () => null,
    hintText: '',
  };

  onBlur = (event) => {
    const { onChange, onBlur } = this.props;

    onChange(event);
    onBlur(event);
  };

  render() {
    const {
      name,
      id,
      inputType,
      onKeyPress,
      value,
      placeholder,
      autocomplete,
      maxLength,
      className,
      validate,
      formatError,
      errorClassName,
      error,
      isDisabled,
      onFocus,
      onKeyDown,
      hintText,
    } = this.props;

    const hasError = !!((error && error.path) || (error && error.name));
    const errorId = error && error.type ? `${name}-error-${error.type}` : `${name}-error`;

    return (
      <ErrorHandler hasError={hasError} shouldScrollToError={validate}>
        <div
          className={classNames(className, {
            [styles.hasError]: hasError,
          })}
        >
          <input
            id={id || name}
            name={name}
            className={styles.input}
            type={inputType}
            onChange={this.props.onChange}
            onKeyPress={onKeyPress}
            onBlur={this.onBlur}
            value={value}
            placeholder={placeholder}
            autoComplete={autocomplete}
            maxLength={maxLength}
            disabled={isDisabled}
            onFocus={onFocus}
            onKeyDown={onKeyDown}
          />
          {hintText && (
            <Text id="hint-text" classNames={styles.hint}>
              {hintText}
            </Text>
          )}
        </div>
        <ErrorMessage
          id={errorId}
          className={errorClassName}
          error={error}
          formatError={formatError}
        />
      </ErrorHandler>
    );
  }
}
